"use strict";
// const btoa_ = global.btoa;
// const atob_ = global.atob;
Object.defineProperty(exports, "__esModule", { value: true });
exports.eqSet = exports.bytesToInt = exports.intToBytes = exports.b64decode = exports.b64encode = void 0;
const btoa_ = typeof btoa !== 'undefined' ? btoa : require('btoa');
const atob_ = typeof atob !== 'undefined' ? atob : require('atob');
function b64encode(u8) {
    return btoa_(String.fromCharCode.apply(null, u8));
}
exports.b64encode = b64encode;
function b64decode(str) {
    return new Uint8Array(atob_(str).split('').map(function (c) { return c.charCodeAt(0); }));
}
exports.b64decode = b64decode;
function intToBytes(int, len) {
    return new Uint8Array(len).map((_, i) => int / Math.pow(256, (len - i - 1)));
}
exports.intToBytes = intToBytes;
function bytesToInt(bytes) {
    return Array.from(bytes).reduce((p, c, i) => p + c * Math.pow(256, (bytes.length - i - 1)), 0);
}
exports.bytesToInt = bytesToInt;
function eqSet(as, bs) {
    if (as.size !== bs.size)
        return false;
    for (var a of as)
        if (!bs.has(a))
            return false;
    return true;
}
exports.eqSet = eqSet;
//# sourceMappingURL=utils.js.map